<template>
  <div v-if="isInitializing" class="full-height flex justify-center items-center">
    <LoaderElement size="large" type="circular" />
  </div>

  <template v-else>
    <VAppBar app elevation="0">
      <AdminNavigationBar />
    </VAppBar>

    <RouterView v-if="route.name && differentLayoutRoutes.includes(route.name)" />

    <VMain v-else class="full-height bg-white px-8">
      <VContainer fluid class="max-width-1200">
        <RouterView />
      </VContainer>
    </VMain>
  </template>
</template>

<script setup lang="ts">
import AdminNavigationBar from '@/components/navigation/AdminNavigationBar.vue'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import LoaderElement from '@/atoms/LoaderElement.vue'
import { type RouteRecordName, useRoute } from 'vue-router'
import { routeNames } from '@/router/routeNames'

const userStore = useUserStore()
const { isInitializing } = storeToRefs(userStore)
const route = useRoute()

const differentLayoutRoutes: RouteRecordName[] = [routeNames.ADMIN_ROUTING]
</script>
